export type { ReconItem, SingleTradeInItem, TradeInState } from '@makemydeal/dr-dash-types';

export const SHOW_INCOMPLETE_TRADE_MODAL = 'SHOW_INCOMPLETE_TRADE_MODAL';
export const HIDE_INCOMPLETE_TRADE_MODAL = 'HIDE_INCOMPLETE_TRADE_MODAL';
export const SET_BYPASS_INCOMPLETE_TRADE_CHECK = 'SET_BYPASS_INCOMPLETE_TRADE_CHECK';
export const CLEAR_BYPASS_INCOMPLETE_TRADE_CHECK = 'CLEAR_BYPASS_INCOMPLETE_TRADE_CHECK';

export interface TradeAction {
    type: string;
    payload: any;
    meta?: {
        middleware: {
            payment?: boolean;
            skipPayment?: boolean;
        };
        isAllowanceSourceIndicatorEnabled?: boolean;
    };
}
